
<span class="loader" 
[style.--scale-loader]=" width / 64"
[style.--loaderThickness]=" thickness + 'px'"
[style.--primaryColor]="primaryColor"
[style.--secondaryColor]="secondaryColor"></span>